import { IconProps } from '../../../icons/icon-props-interface';

const IconAccountHealth: React.FC<IconProps> = ({ color = 'var(--color-primary-2)' }: IconProps): JSX.Element => (

    <svg className="nav-link-l-icon" width="17" height="18" viewBox="0 0 17 18" fill="none">
        {/*Band-aid main body */}
        <path
            d="M3 6H14C14.5523 6 15 6.44772 15 7V11C15 11.5523 14.5523 12 14 12H3C2.44772 12 2 11.5523 2 11V7C2 6.44772 2.44772 6 3 6Z"
            stroke="#455584" stroke-width="0.8" fill="none"/>
        {/*Band-aid left adhesive */}
        <path d="M1.5 7.5H3V10.5H1.5C1.22386 10.5 1 10.2761 1 10V8C1 7.72386 1.22386 7.5 1.5 7.5Z" stroke="#455584"
              stroke-width="0.8" fill="none"/>
        {/*Band-aid right adhesive */}
        <path d="M14 7.5H15.5C15.7761 7.5 16 7.72386 16 8V10C16 10.2761 15.7761 10.5 15.5 10.5H14V7.5Z" stroke="#455584"
              stroke-width="0.8" fill="none"/>
        {/*Center pad area */}
        <rect x="6" y="7.5" width="5" height="3" stroke="#455584" stroke-width="0.4" fill="none"/>
        {/*Small perforations */}
        <circle cx="7" cy="8.5" r="0.3" fill="#455584"/>
        <circle cx="8.5" cy="8.5" r="0.3" fill="#455584"/>
        <circle cx="10" cy="8.5" r="0.3" fill="#455584"/>
        <circle cx="7" cy="9.5" r="0.3" fill="#455584"/>
        <circle cx="8.5" cy="9.5" r="0.3" fill="#455584"/>
        <circle cx="10" cy="9.5" r="0.3" fill="#455584"/>
    </svg>

);


export default IconAccountHealth;
